import React from 'react';
import { InputBase, Button } from '@material-ui/core';
import { Add as AddIcon, Search as SearchIcon } from '@material-ui/icons';
import styles from './index.module.scss';

const SideMenuSearch = () => {
    return (
        <div className={styles.container}>
            <div className={styles.search}>
                <SearchIcon className={styles.searchIcon}/>
                <InputBase className={styles.input}
                           placeholder="Search Contacts, Groups or Projects"
                           inputProps={{ 'aria-label': 'Search Contacts, Groups or Projects' }} />
            </div>
            <Button variant="contained" color="primary" className={styles.addButton}>
                <AddIcon />
            </Button>
        </div>
    );
};

export default SideMenuSearch;